<template>
  <div>
    <table class="table-wrap" v-if="rowsData.length">
      <thead>
        <tr>
          <th v-if="rowSelection">
            <input type="checkbox" :value="rowSelection.hasSelectAll" v-model="rowSelection.hasSelectAll" @change="onSelectChange">
          </th>
          <th v-for="col in columns" :key="col.key" :style="getStyle(col)">{{col.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rowsData" :key="index">
          <th v-if="rowSelection">
            <input type="checkbox" :value="row._selected" v-model="row._selected" @change="e => onItemChange(e, row)">
          </th>
          <td v-for="col in columns" :key="col.key + index" :style="getStyle(col)">
            <slot :title="row[col.dataIndex] || row[col.key]" :row="row" :col="col" :index="index" v-if="col.fieldType != 'File' ">{{ row[col.dataIndex] || row[col.key] }}</slot>
            <slot :title="row[col.dataIndex] || row[col.key]" :row="row" :col="col" :index="index" v-if="col.fieldType == 'File' && row[col.dataIndex].length>0 "><a :href="row[col.dataIndex][0].url" target="_blank" >{{row[col.dataIndex][0].name}}</a></slot>
          </td>
        </tr>
      </tbody>
    </table>
    <Empty v-else />
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array
    },
    rowsData: {
      type: Array
    },
    rowSelection: {
      type: Object
    }
  },
  computed: {
  },
  mounted() {
		console.log(this.columns);
    console.log(this.rowsData);
    // debugger;
  },
  methods: {
    getStyle(col) {
      let style = '';
      if (col.width) {
        style = `width: ${col.width}`;
      }
      if (col.maxWidth) {
        style += `max-width: ${col.maxWidth}`
      }
      return style;
    },
    getClassName(row, col) {
      if (col.className instanceof Function) {
        return col.className(row);
      }
      if (typeof col.className === 'string') {
        return col.className;
      }
      return '';
    },
    onSelectChange() {
      const hasSelectAll = this.rowSelection.hasSelectAll;
      this.rowsData.map(item => {
        item._selected = hasSelectAll;
      });
      this.rowSelection.onChange(this.rowsData.filter(row => row._selected));
    },
    onItemChange(event, row) {
      const canSelectedRows = this.rowsData.filter(row => !row._disabled);
      const selectedRows = canSelectedRows.filter(row => row._selected);
      if (canSelectedRows.length === selectedRows.length && selectedRows.length !== 0) {
        this.rowSelection.hasSelectAll = true;
      } else {
        this.rowSelection.hasSelectAll = false;
      }
      this.rowSelection.onChange(selectedRows);
    }
  }
}
</script>

<style lang="less" scoped>
.table-wrap {
  width: 100%;

  thead {
    height: 50px;
    background: #F1F1F1;

    th {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #131415;
      line-height: 50px;
      padding: 0 10px;
    }
  }

  tbody {
    padding: 16px 0;

    tr {
      td {
        height: 46px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        text-align: center;
        line-height: 46px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 10px;
      }
    }
  }

  .table-op {

    a {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-right: 8px;
      cursor: pointer;
      
      &.del {
        &:hover {
          color: #FF3B2F;
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }

    .split-line {
      margin-right: 8px;
      height: 14px;
      width: 1px;
      display: inline-block;
      margin-top: 2px;
      background: #D8D8D8;
    }
  }
}
</style>